export default "__VITE_ASSET__f23ba7e2__"